import type { ILanguageResources, ITranslationModule } from '../../../interfaces';
import { interpolate } from '../../../global';

class Id {
  private constructor() {}
  public static readonly prefix = 'UI.scripts.fabricationJobs.FabricationJobItemsTable.';
  public static readonly itemNumberTitle = `${Id.prefix}itemNumberTitle`;
  public static readonly quoteNumberTitle = `${Id.prefix}quoteNumberTitle`;
  public static readonly imageTitle = `${Id.prefix}imageTitle`;
  public static readonly locationDescriptionTitle = `${Id.prefix}locationDescriptionTitle`;
  public static readonly optionsTitle = `${Id.prefix}optionsTitle`;
  public static readonly siteOverridesTitle = `${Id.prefix}siteOverridesTitle`;
  public static readonly tagsTitle = `${Id.prefix}tagsTitle`;
  public static readonly qtyTitle = `${Id.prefix}qtyTitle`;
  public static readonly editMenuItem = `${Id.prefix}editMenuItem`;
  public static readonly removeMenuItem = `${Id.prefix}removeMenuItem`;
  public static readonly loadingItems = `${Id.prefix}loadingItems`;
  public static readonly noOverrides = `${Id.prefix}noOverrides`;
  public static readonly unitsHaveOverrides = `${Id.prefix}unitsHaveOverrides`;
  public static readonly notesToClient = `${Id.prefix}notesToClient`;
  public static readonly notesToManufacturer = `${Id.prefix}notesToManufacturer`;
  public static readonly loadCrossServiceDataFailed = `${Id.prefix}loadCrossServiceDataFailed`;
  public static readonly quoteNumberLink = `${Id.prefix}quoteNumberLink`;
  public static readonly itemNumberLabel = `${Id.prefix}itemNumberLabel`;
}

export class LangFabricationJobItemsTable {
  private constructor() {}
  public static itemNumberTitle(): string {
    return interpolate(Id.itemNumberTitle);
  }
  public static quoteNumberTitle(): string {
    return interpolate(Id.quoteNumberTitle);
  }
  public static imageTitle(): string {
    return interpolate(Id.imageTitle);
  }
  public static locationDescriptionTitle(): string {
    return interpolate(Id.locationDescriptionTitle);
  }
  public static optionsTitle(): string {
    return interpolate(Id.optionsTitle);
  }
  public static siteOverridesTitle(): string {
    return interpolate(Id.siteOverridesTitle);
  }
  public static tagsTitle(): string {
    return interpolate(Id.tagsTitle);
  }
  public static qtyTitle(): string {
    return interpolate(Id.qtyTitle);
  }
  public static editMenuItem(): string {
    return interpolate(Id.editMenuItem);
  }
  public static removeMenuItem(): string {
    return interpolate(Id.removeMenuItem);
  }
  public static loadingItems(): string {
    return interpolate(Id.loadingItems);
  }
  public static noOverrides(): string {
    return interpolate(Id.noOverrides);
  }
  public static unitsHaveOverrides(overrideCount: number, quantity: number): string {
    return interpolate(Id.unitsHaveOverrides, {
      overrideCount: overrideCount.toString(),
      quantity: quantity.toString()
    });
  }
  public static notesToClient(): string {
    return interpolate(Id.notesToClient);
  }
  public static notesToManufacturer(): string {
    return interpolate(Id.notesToManufacturer);
  }
  public static loadCrossServiceDataFailed(): string {
    return interpolate(Id.loadCrossServiceDataFailed);
  }
  public static quoteNumberLink(quoteNumber: string): string {
    return interpolate(Id.quoteNumberLink, { quoteNumber });
  }
  public static itemNumberLabel(itemNumber: string): string {
    return interpolate(Id.itemNumberLabel, { itemNumber });
  }
}

export class FabricationJobItemsTableModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    register.add(Id.itemNumberTitle, '#', 'Column title for fabrication job item number');
    register.add(Id.quoteNumberTitle, 'Quote #', 'Column title for quote number');
    register.add(Id.imageTitle, 'Image', 'Column title for item image');
    register.add(
      Id.locationDescriptionTitle,
      'Location / Description',
      'Column title for item location and description'
    );
    register.add(Id.optionsTitle, 'Options', 'Column title for item options');
    register.add(Id.siteOverridesTitle, 'Site Overrides', 'Column title for per-unit site measurement overrides');
    register.add(Id.tagsTitle, 'Tags', 'Column title for item tags');
    register.add(Id.qtyTitle, 'Qty', 'Column title for item quantity');
    register.add(Id.editMenuItem, 'Edit', 'Menu item to edit a fabrication job item');
    register.add(Id.removeMenuItem, 'Remove', 'Menu item to remove a fabrication job item');
    register.add(Id.loadingItems, 'Loading items...', 'Text shown while loading fabrication job items');
    register.add(Id.noOverrides, 'no overrides', 'Text shown when item has no site measurement overrides');
    register.add(
      Id.unitsHaveOverrides,
      '{{overrideCount}}/{{quantity}} units have overrides',
      'Text showing how many units have site measurement overrides'
    );
    register.add(Id.notesToClient, 'Notes to Client:', 'Label for notes to client');
    register.add(Id.notesToManufacturer, 'Notes to Manufacturer:', 'Label for notes to manufacturer');
    register.add(
      Id.loadCrossServiceDataFailed,
      'Failed to load quote details for job items.',
      'Error toast when cross-service data loading fails'
    );
    register.add(Id.quoteNumberLink, '#{{quoteNumber}}', 'Quote number display format with hash prefix');
    register.add(Id.itemNumberLabel, '#{{itemNumber}}', 'Item number display format with hash prefix');
  }
}
